import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useHistory } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Input from '@material-ui/core/Input';
import { Grid } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import { createIMCDraftRequest } from '../store/actions/index';
import './styles.css';
import { CommonConfig } from '../../../config/common-config';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../components/loaderpopup/success';
import ErrorPopUp from '../../../components/loaderpopup/error';
import PreviewImage from '../../../assets/previewImage.png';
import PreviewModal from '../../../components/modal/previewModal';
import deleteImage from '../../../assets/deleteImage.png';
import TabList from '../../../components/checklistTab/tabList';
import moment from 'moment';
import downloadImage from '../../../assets/downloadImage.png';
import buttonDisable from '../../../components/disableField/buttonDisable';
import { userType } from '../../../config/usertypeValue';

const useStyles = makeStyles((theme) => ({
    btnbottom: {
        borderBottom: '#feef6',
    },

    root: {
        boxShadow: '0px 5px 10px #efefef !important',
        borderRadius: '8px',
        minHeight: '300px',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        color: '#727272',
        fontSize: '20px',
        fontFamily: 'Rubik',
        fontWeight: '500',
        marginBottom: '20px',
    },
    pos: {
        marginBottom: 12,
    },
    rootCard: {
        marginBottom: '20px',
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        '& > *': {
            margin: theme.spacing(1),
        },
    },

    bottomLine: {
        padding: '0',
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    inlineDisplayFont: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 20px',
            color: '#7779ba',
            marginTop: '-10px',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        margin: '0px !important',
    },
    inlinebutton: {
        padding: '0',
        margin: '0',
        '& li': {
            listStyle: 'none',
            display: 'inline-block',
            marginRight: '15px',
            width: '100%',
        },
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    fileNameMargin: {
        marginTop: '6px',
        marginBottom: '0px',
    },
    flexRow: {
        flexDirection: 'row !important',
    },
    removeButton: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        marginRight: '15px !important',
    },
    downloadImg: {
        width: '25px',
        height: '26px',
        position: 'relative',
        top: '6px',
        left: '6px',
    },
    imgView: {
        borderRadius: '8px',
        marginLeft: '12px',
        background: '#e8e7e7',
        padding: '6px 0px 5px 10px',
        marginBottom: '10px',
    },
    pointer: {
        pointerEvents: 'none !important',
    },
    disableBtn: {
        color: '#bbb !important',
        background: '#cecece !important',
        padding: '6px 40px !important',
        fontFamily: 'Rubik',
        textTransform: 'none !important',
    },
}));

export default function IMCDraftDocument(props) {
    const classes = useStyles();
    const dispatch = useDispatch({});
    const [showLoaderSubmit, setShowLoaderSubmit] = useState(false);
    const [showLoaderSave, setShowLoaderSave] = useState(false);
    const [success, setSuccess] = useState(false);
    const [successpopsubmit, setSuccessPopSubmit] = useState(false);
    const [error, setError] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    // const [state, setState] = React.useState({
    //     checkedA: true,
    // });
    const history = useHistory();
    const [filename, setFilename] = useState('');
    const [uploadSuccessfully, setUploadSuccessfully] = useState('');
    const [isDisable, setIsDisable] = useState(true);
    const [isfileInvalid, setIsfileInvalid] = useState('');
    const [selectedFileData, setSelectedFileData] = useState(null);
    const [URLValue, setURLValue] = useState();
    const [URLValueData, setURLValueData] = useState([]);
    const [handleOpen, setHandleOpen] = useState(false);
    const [clearData, setClearData] = useState('');
    const [attachedFilename, setAttachedFilename] = useState('');
    const [uploadDisable, setUploadDisable] = useState(true);
    const [fileIndex, setFileIndex] = useState();
    const [visible, setVisible] = React.useState(false);
    const [downloadFile, setDownloadFile] = useState('');
    const [attachedFileIMC, setAttachedFileIMC] = useState('');
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const stageId = useSelector((state) => state.serviceCheckListReducer.selectedStageId);
    const imcdraftsavevalue = useSelector((state) => state.draftreducer.imcdraftsave);
    const imcdraftsavevalue1 = imcdraftsavevalue && imcdraftsavevalue.params;
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantName = tennantDetails && tennantDetails.tennantName;
    const imcdraftsavevalue2 = imcdraftsavevalue1 && imcdraftsavevalue1.draftDocuments;
    const [fileList, setFileList] = useState([]);
    const UploadFileList = [];
    let dateValue = new Date().toISOString().split('T')[0];
    const [checklist, setChecklist] = useState([]);
    const [IMCList, setIMCList] = useState([]);
    const tempArr = [];
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    const [initialValues, setInitialValues] = useState({
        version: 1,
        date: dateValue,
        remarksIMC: '',
        remarksByClient: '',
        addQue: '',
    });

    const [attachmentFlag, setAttachmentFlag] = useState(false);

    const isFileUpload = (event, selectorFiles, index) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(doc|docx|xlsx|xls|csv|png|jpeg|jpg|pdf|zip)$');
            setFilename(selectorFiles[0].name);
            // console.log('aaaaa', pattern.test(selectorFiles[0].name));
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalid('');
                setUploadDisable(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalid('Please select the file size less than 10MB');
                    setUploadDisable(true);
                } else {
                    setSelectedFileData(selectorFiles[0]);
                    handleInputChange(event, index, selectorFiles[0].name);
                    setFileIndex(index);
                }
            } else {
                setIsfileInvalid('Please select valid file formate i.e pdf');
                // setUploadDisable(true);
                setUploadDisable(true);
            }
        }
    };

    const fileUpload = () => {
        const data = new FormData();
        data.append('file', selectedFileData);

        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${tennantName}/${serviceIdValue}/myimage`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                // console.log('wre282', response.data);
                if (response.data) {
                    setAttachmentFlag(false);

                    setURLValue(response.data && response.data.substring(response.data.lastIndexOf('/') + 1));
                    setAttachedFile(response.data);
                    setAttachedFilename(filename);
                    setUploadSuccessfully('Uploaded a file successfully');
                    setTimeout(() => {
                        handleClose();
                    }, 500);
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisable(true);
                }
            });
    };

    const downloadCoreFile = (file) => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`, {
                // method: 'GET',
                headers: {
                    Authorization: bearerToken,
                },
                responseType: 'blob',
            })
            .then((response) => {
                const link = document.createElement('a');
                link.href = response.config.url;
                link.setAttribute('download', response.config.url);
                link.click();
            });
    };

    // const setURLValueList = () => {

    // }

    const setAttachedFile = (data) => {
        const list = [...fileList];
        list[fileIndex]['filePath'] = data;
        setFileList(list);
    };

    const handleClick = () => {
        setHandleOpen(true);
        setUploadSuccessfully('');
        setUploadDisable(true);
        setClearData('');
        handleAddClick();
    };

    const handleClose = () => {
        setShowLoaderSave(false);
        setShowLoaderSubmit(false);
        setHandleOpen(false);
        setIsfileInvalid('');
        setFilename(null);
        setSuccess(false);
        setSuccessPopSubmit(false);
        setError(false);
    };

    const handleDisable = (value) => {
        setIsDisable(value);
    };

    // handle input change
    const handleInputChange = (e, index, name) => {
        const list = [...fileList];
        list[index]['fileUrl'] = e.target.value;
        list[index]['fileName'] = name;
        setFileList(list);
    };

    // handle click event of the Add file list
    const handleAddClick = () => {
        setFileList([...fileList, { fileUrl: '', fileName: '', filePath: '' }]);
    };

    // handle click event of the Remove button
    const handleRemoveClick = (index) => {
        const list = [...fileList];
        list.splice(index, 1);
        setFileList(list);
        setURLValueData(list);
    };

    const handleModalClose = () => {
        setVisible(false);
    };

    const handlePreviewModal = (file) => {
        setDownloadFile(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`);
        setShowLoaderSave(true);
        setTimeout(() => {
            setShowLoaderSave(false);
            setVisible(true);
        }, 1000);
    };

    const validationSchema = Yup.object().shape({
        version: Yup.string().required('Please Enter the Version'),
        date: Yup.date(new Date()).required('Please Enter the Date'),
        remarksIMC: Yup.string().required('Please Enter the Remarks'),
        remarksByClient: Yup.string(),
        addQue: Yup.string(),
    });

    const handleSubmit = (values) => {
        // setShowLoaderSave(true);
        let IMCArr = [];
        fileList.filter((ele) => {
            UploadFileList.push(ele.filePath);
        });

        const obj = {
            versionNumber: values.version,
            date: values.date,
            attachmentsByImc: UploadFileList,
            remarkByImc: values.remarksIMC,
            attachmentsByItecteam: [],
            additionalQuestionNotes: values.addQue,
            remarkByClient: '',
            draftDocument: null,
            stage: 'draftDocument',
        };

        if (checklist) {
            const isPresent = checklist.some(function (el) {
                return el.versionNumber === values.version;
            });
            if (!isPresent) {
                checklist.push(obj);
            }
            checklist.filter((ele, i) => {
                if (values.version === ele.versionNumber) {
                    ele.versionNumber = values.version;
                    ele.date = values.date;
                    ele.attachmentsByImc = UploadFileList;
                    ele.remarkByImc = values.remarksIMC;
                    ele.additionalQuestionNotes = values.addQue;
                }
            });
        }
        const objData = {
            versionNumber: values.version,
            date: values.date,
            attachmentsByImc: UploadFileList,
            remarkByImc: values.remarksIMC,
            attachmentsByItecteam: [],
            additionalQuestionNotes: values.addQue,
            remarkByClient: '',
            draftDocument: null,
            stage: 'draftDocument',
        };
        IMCArr.push(objData);

        const data = {
            serviceId: serviceIdValue,
            remarks: 'Remarks',
            draftDocuments: checklist && checklist.length ? checklist : IMCArr,
        };

        // console.log('data', data)

        if (data) {
            data.draftDocuments.filter((draft, i) => {
                if (initialValues.version === draft.versionNumber) {
                    if (draft.attachmentsByImc.length < 1) {
                        setAttachmentFlag(true);
                    } else {
                        setShowLoaderSave(true);
                        axios
                            .put(`${CommonConfig.dev.baseUrl1}/api/itr/draft-statements/save-em/${tennantName}`, data, {
                                headers: {
                                    Authorization: bearerToken,
                                },
                            })
                            .then((response) => {
                                if (response.data === 'SUCCESS') {
                                    handleDisable(false);

                                    setTimeout(() => {
                                        setShowLoaderSave(false);
                                        setSuccess(true);
                                    }, 1500);
                                    setTimeout(() => {
                                        setSuccess(false);
                                        IMCArr = [];
                                        // navigateBack();
                                    }, 3000);
                                }
                            })
                            .catch((error) => {
                                const errResult = error.response;
                                if (errResult && errResult.data) {
                                    setTimeout(() => {
                                        setShowLoaderSave(false);
                                        setError(true);
                                    }, 1500);
                                    setTimeout(() => {
                                        setError(false);
                                    }, 5000);
                                    setErrorMsgGenerateRecceipt(errResult.data.message);
                                }
                            });

                        dispatch(createIMCDraftRequest({ params: data }));
                    }
                }
            });
        }
    };

    useEffect(() => {
        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/itr/draft-statements/by-serviceId/${tennantName}/${serviceIdValue}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response && response.data) {
                    setChecklist(response.data);
                }
            })
            .catch((error) => { });

        if (history.location && history.location.state && history.location.state.data) {
            // formatDate(history.location.state.data)
            setChecklist([history.location.state.data]);
            setResponse(history.location.state.data);
            setIsDisable(false);
        } else {
            axios
                .get(`${CommonConfig.dev.baseUrl1}/api/itr/draft-statements/by-serviceId/${tennantName}/${serviceIdValue}`, {
                    headers: {
                        Authorization: bearerToken,
                    },
                })
                .then((response) => {
                    if (response && response.data) {
                        setChecklist(response.data);
                        if (stageId === 18) {
                            let temp = {
                                version: response.data.length + 1,
                                date: dateValue,
                                remarksIMC: '',
                                remarksByClient: '',
                                addQue: '',
                            };
                            setInitialValues(temp);
                        }
                    }
                })
                .catch((error) => { });
        }
    }, [userToken, history]);

    function formatDate(props) {
        return props.map((element) => {
            const tempStartDate = element.date;
            const pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
            const formatDate = new Date(tempStartDate.replace(pattern, '$3-$2-$1'));
            element.date = moment(formatDate).format('YYYY-MM-DD');
        });
    }

    const setResponse = (val) => {
        let response = {
            data: [val],
        };
        const tempFileList = [];
        setFileList([]);

        // tempFileList = [];
        response.data[response.data.length - 1].attachmentsByImc.filter((ele) => {
            let tempObj = { fileUrl: '', fileName: ele.substring(ele.lastIndexOf('/') + 1), filePath: ele };
            tempFileList.push(tempObj);
        });
        setFileList(tempFileList);
        setAttachedFileIMC(
            response.data && response.data[response.data.length - 1] && response.data[response.data.length - 1].attachmentsByItecteam
        );
        const initialValues = {};
        initialValues['version'] = '' || (response.data && response.data[response.data.length - 1].versionNumber);
        initialValues['date'] = '' || (response.data && response.data[response.data.length - 1].date.split('-').reverse().join('-'));
        initialValues['remarksIMC'] = '' || (response.data && response.data[response.data.length - 1].remarkByImc);
        initialValues['remarksByClient'] = '' || (response.data && response.data[response.data.length - 1].remarkByClient);
        initialValues['uploadURL'] = '' || (response.data && response.data[response.data.length - 1].uploadURL);
        initialValues['addQue'] = '' || (response.data && response.data[response.data.length - 1].additionalQuestionNotes);
        initialValues['uploadforshareclients'] = '' || (response.data && response.data[response.data.length - 1].uploadforshareclients);
        setInitialValues(initialValues);
        setIMCList(response.data);
    };

    const handleSubmitClick = (imcdraftsavevalue2, values) => {
        let IMCArr = [];
        setShowLoaderSubmit(true);
        tempArr.push(IMCList);
        fileList.filter((ele) => {
            UploadFileList.push(ele.filePath);
        });

        const obj = {
            versionNumber: values.version,
            date: values.date,
            attachmentsByImc: UploadFileList,
            remarkByImc: values.remarksIMC,
            attachmentsByItecteam: [],
            additionalQuestionNotes: values.addQue,
            remarkByClient: '',
            draftDocument: null,
            stage: 'draftDocument',
        };

        if (checklist && checklist.length) {
            const isPresent = checklist.some(function (el) {
                return el.versionNumber === values.version;
            });
            if (!isPresent) {
                checklist.push(obj);
            }
            checklist.filter((ele, i) => {
                if (values.version === ele.versionNumber) {
                    ele.versionNumber = values.version;
                    ele.date = values.date;
                    ele.attachmentsByImc = UploadFileList;
                    ele.remarkByImc = values.remarksIMC;
                    ele.additionalQuestionNotes = values.addQue;
                }
            });
        }

        const objData = {
            versionNumber: values.version,
            date: values.date,
            attachmentsByImc: UploadFileList,
            remarkByImc: values.remarksIMC,
            attachmentsByItecteam: [],
            additionalQuestionNotes: values.addQue,
            remarkByClient: '',
            draftDocument: null,
            stage: 'draftDocument',
        };
        IMCArr.push(objData);

        const data = {
            serviceId: serviceIdValue,
            remarks: 'Remarks',
            draftDocuments: checklist && checklist.length ? checklist : IMCArr,
        };

        // console.log('handleSubmitClick', data);

        axios
            .post(`${CommonConfig.dev.baseUrl1}/api/itr/draft-statements/create/${tennantName}`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                //console.log('response', response.data);
                if (response.data === 'SUCCESS') {
                    setTimeout(() => {
                        setShowLoaderSubmit(false);
                        setSuccessPopSubmit(true);
                    }, 1500);
                    setTimeout(() => {
                        history.push({
                            pathname: '/menu/openservice',
                        });
                    }, 3000);
                }
            })
            .catch((error) => {
                const errResult = error.response;
                if (errResult.data) {
                    setTimeout(() => {
                        setShowLoaderSubmit(false);
                        setError(true);
                    }, 1500);
                    setTimeout(() => {
                        setError(false);
                    }, 5000);
                    setErrorMsgGenerateRecceipt(errResult.data.message);
                }
            });
    };

    // const handleVersionChange = (value, checklist) => {
    // const tempFileList = [];
    // setFileList([]);
    // if (value) {
    //     const initialValues = {};
    //     if (checklist && checklist.length) {
    //         checklist.filter((list, i) => {
    //             if (list.versionNumber === value) {
    //                 setIMCIndex(i);
    //                 initialValues['version'] = list.versionNumber;
    //                 initialValues['date'] = list.date;
    //                 initialValues['remarksIMC'] = list.remarkByImc;
    //                 initialValues['uploadURL'] = list.uploadURL;
    //                 initialValues['addQue'] = list.additionalQuestionNotes;
    //                 initialValues['uploadforshareclients'] = list.uploadforshareclients;
    //                 initialValues['remarksByClient'] = list.remarksByClient;
    //                 setInitialValues(initialValues);

    //                 list.attachmentsByImc.filter((ele) => {
    //                     ////console.log(ele)
    //                     let tempObj = { fileUrl: "", fileName: ele.substring(ele.lastIndexOf('-') + 1), filePath: ele };
    //                     tempFileList.push(tempObj)
    //                 })
    //                 setFileList(tempFileList);
    //                 setAttachedFileIMC(list && list.attachmentsByItecteam && list.attachmentsByItecteam)
    //             }
    //         })
    //     }
    //     if (!tempFileList.length) {
    //         initialValues['version'] = value
    //         initialValues['date'] = ''
    //         initialValues['remarksIMC'] = ''
    //         initialValues['uploadURL'] = ''
    //         initialValues['addQue'] = ''
    //         initialValues['uploadforshareclients'] = ''
    //         initialValues['remarksByClient'] = ''
    //         setInitialValues(initialValues)
    //         setFileList([]);
    //         setAttachedFileIMC('');
    //         // let tempObj = { fileUrl: "", fileName: "", filePath: "" };
    //         // tempFileList.push(tempObj)
    //         setFileList(tempFileList);
    //     }
    // }
    // }

    const navigateBack = () => {
        history.push({
            pathname: '/menu/imc-draft-document',
            state: { path: 'openservices' },
        });
    };

    return (
        <div>
            <TabList />
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values) => handleSubmit(values)}
                enableReinitialize
            >
                {(formik) => {
                    return (
                        <>
                            {success ? (
                                <SuccessPopUp
                                    open={success}
                                    showSuccess={success}
                                    handleClose={handleClose}
                                    title="Document saved successfully"
                                />
                            ) : null}
                            {successpopsubmit ? (
                                <SuccessPopUp
                                    open={successpopsubmit}
                                    showSuccess={successpopsubmit}
                                    handleClose={handleClose}
                                    title="Draft Statement submitted successfully"
                                />
                            ) : null}
                            {error ? (
                                <ErrorPopUp open={error} showError={error} handleClose={handleClose} title={errorMsgGenerateRecceipt} />
                            ) : null}

                            <form className="itecform" onSubmit={formik.handleSubmit}>
                                <Card className={classes.root}>
                                    <CardContent>
                                        <Grid container spacing={3} className="main-container w100i">
                                            <Grid item xs={12} sm={6}>
                                                <FormControl fullWidth>
                                                    <label className="labelCls" shrink>
                                                        {' '}
                                                        Version no <span style={{ color: '#ff0a047a' }}>*</span>
                                                    </label>
                                                    <Input
                                                        disabled
                                                        className={classes.bottomLine}
                                                        name="version"
                                                        placeholder="Enter Version"
                                                        value={formik.values.version}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {/* <Select
                                                        native
                                                        className={classes.bottomLine}
                                                        name="version"
                                                        value={formik.values.version}
                                                        onChange={(e) => {
                                                            formik.handleChange(e);
                                                            handleVersionChange(e.target.value, checklist);
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                        placeholder="Select the Version on the Draft Statements"
                                                        IconComponent={() => <FontAwesomeIcon icon={faAngleDown} />}
                                                        disabled={usertype === "Other employee users"}
                                                    >
                                                        <option value="Version1">Version 0.1</option>
                                                        <option value="Version2">Version 0.2</option>
                                                        <option value="Version3">Version 0.3</option>
                                                    </Select> */}
                                                    {formik.touched.version && formik.errors.version ? (
                                                        <span className="itec-validationError">{formik.errors.version}</span>
                                                    ) : null}
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <FormControl fullWidth>
                                                    <label className="labelCls" shrink>
                                                        {' '}
                                                        Date <span style={{ color: '#ff0a047a' }}>*</span>
                                                    </label>
                                                    <Input
                                                        disabled
                                                        type="date"
                                                        className="bottom"
                                                        format="YYYY-MM-DD"
                                                        name="date"
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.date}
                                                        inputProps={{ max: '9999-12-31' }}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                    {formik.touched.date && formik.errors.date ? (
                                                        <span className="itec-validationError">{formik.errors.date}</span>
                                                    ) : null}
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={6} style={{ paddingTop: '24px' }}>
                                                <FormControl fullWidth className={classes.margin}>
                                                    <Button
                                                        disabled={
                                                            buttonDisable(stageId, userType.value) || usertype === 'Other employee users'
                                                        }
                                                        onClick={handleClick}
                                                        variant="outlined"
                                                        color="primary"
                                                        size="small"
                                                        className={classes.button}
                                                    >
                                                        Upload
                                                        <span style={{ color: '#ff0a047a' }}>*</span>
                                                    </Button>
                                                    {attachmentFlag ? <p className="itec-validationError">Attachment is required</p> : null}
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <FormControl fullWidth>
                                                    <InputLabel htmlFor="enter-question" shrink>
                                                        Remarks by {tennantName} <span style={{ color: '#ff0a047a' }}>*</span>
                                                    </InputLabel>
                                                    <Input
                                                        disabled={
                                                            usertype === 'Other employee users' || buttonDisable(stageId, userType.value)
                                                        }
                                                        className={classes.bottomLine}
                                                        id="enter-question"
                                                        name="remarksIMC"
                                                        placeholder="Enter Remarks"
                                                        value={formik.values.remarksIMC}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.remarksIMC && formik.errors.remarksIMC ? (
                                                        <span className="itec-validationError">{formik.errors.remarksIMC}</span>
                                                    ) : null}
                                                </FormControl>
                                            </Grid>
                                            {fileList.length > 0
                                                ? fileList.map((file, index) => {
                                                    return (
                                                        <span style={{ display: file && file.fileName ? '' : 'none' }}>
                                                            <Grid item xs={12} sm={12} className={classes.imgView}>
                                                                <ul className={classes.inlinebutton}>
                                                                    <li>
                                                                        <FormControl fullWidth className={classes.margin}>
                                                                            <span style={{ display: 'flex' }}>
                                                                                {file.fileName ? (
                                                                                    <span
                                                                                        style={{ marginRight: '8px', paddingTop: '5px' }}
                                                                                    >
                                                                                        {file.fileName
                                                                                            .substring(file.fileName.lastIndexOf('/') + 1)
                                                                                            .substring(0, 15) + '...'}
                                                                                    </span>
                                                                                ) : null}
                                                                                {file.fileName ? (
                                                                                    <div
                                                                                        style={{
                                                                                            width: '25%',
                                                                                            display: file ? 'flex' : 'none',
                                                                                        }}
                                                                                    >
                                                                                        <span
                                                                                            onClick={() =>
                                                                                                handlePreviewModal(file.filePath)
                                                                                            }
                                                                                        >
                                                                                            <Tooltip title="Preview">
                                                                                                <img
                                                                                                    src={PreviewImage}
                                                                                                    alt="PreviewImage"
                                                                                                    className="fileView"
                                                                                                />
                                                                                            </Tooltip>
                                                                                        </span>
                                                                                        {stageId === 16 ||
                                                                                            stageId === 17 ||
                                                                                            stageId === 18 ? (
                                                                                                <span
                                                                                                    className={
                                                                                                        buttonDisable(stageId, userType.value)
                                                                                                            ? classes.pointer
                                                                                                            : ''
                                                                                                    }
                                                                                                    onClick={() => handleRemoveClick(index)}
                                                                                                >
                                                                                                    <Tooltip title="Delete">
                                                                                                        <img
                                                                                                            src={deleteImage}
                                                                                                            alt="deleteImage"
                                                                                                            className="closeImg"
                                                                                                        />
                                                                                                    </Tooltip>
                                                                                                </span>
                                                                                            ) : (
                                                                                                ''
                                                                                            )}
                                                                                        <span
                                                                                            onClick={() =>
                                                                                                downloadCoreFile(file.filePath)
                                                                                            }
                                                                                        >
                                                                                            <Tooltip title="Download">
                                                                                                <img
                                                                                                    src={downloadImage}
                                                                                                    alt="downloadImage"
                                                                                                    className={classes.downloadImg}
                                                                                                />
                                                                                            </Tooltip>
                                                                                        </span>
                                                                                    </div>
                                                                                ) : null}
                                                                            </span>

                                                                            <Dialog
                                                                                onClose={handleClose}
                                                                                PaperProps={{
                                                                                    className: 'QandADailogBox',
                                                                                    style: { padding: '20px' },
                                                                                }}
                                                                                aria-labelledby="form-dialog-title"
                                                                                open={handleOpen}
                                                                                clear={clearData}
                                                                            >
                                                                                <DialogTitle id="form-dialog-title">
                                                                                    Upload File
                                                                                  </DialogTitle>
                                                                                <DialogContent
                                                                                    style={{
                                                                                        textAlign: 'center',
                                                                                    }}
                                                                                >
                                                                                    <Button
                                                                                        className="btnOrange"
                                                                                        variant="outlined"
                                                                                        component="label"
                                                                                        color="default"
                                                                                    >
                                                                                        <i className="btnIcon">
                                                                                            <FontAwesomeIcon icon={faPlus} />
                                                                                        </i>{' '}
                                                                                        Add File
                                                                                          <input
                                                                                            onChange={(e) =>
                                                                                                isFileUpload(e, e.target.files, index)
                                                                                            }
                                                                                            type="file"
                                                                                            style={{
                                                                                                display: 'none',
                                                                                            }}
                                                                                            accept=".jpeg,.png,.csv,.zip,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                                                        />
                                                                                    </Button>
                                                                                    {/* <div style={{ fontSize: '12px', marginTop: '4px' }}>
                                                                                    <strong>Note:</strong> Attach only PDF
                                                                                </div> */}
                                                                                    {filename ? (
                                                                                        <p className="fileName">
                                                                                            {filename.substring(0, 15) + '...'}
                                                                                        </p>
                                                                                    ) : null}

                                                                                    {filename ? (
                                                                                        isfileInvalid && isfileInvalid.length > 0 ? (
                                                                                            <p className="noteCss">
                                                                                                Note: {isfileInvalid}
                                                                                            </p>
                                                                                        ) : (
                                                                                                ''
                                                                                            )
                                                                                    ) : null}
                                                                                </DialogContent>
                                                                                <p className="fileNameGreen">{uploadSuccessfully}</p>
                                                                                <DialogActions className="paddingBtm txtCenter">
                                                                                    <Button
                                                                                        className={
                                                                                            uploadDisable
                                                                                                ? classes.disableBtn
                                                                                                : 'btnBluepop'
                                                                                        }
                                                                                        onClick={fileUpload}
                                                                                        variant="contained"
                                                                                        disabled={uploadDisable}
                                                                                        component="label"
                                                                                        color="default"
                                                                                    >
                                                                                        Upload
                                                                                      </Button>
                                                                                    <Button
                                                                                        className="btnBluepop"
                                                                                        disabled={uploadSuccessfully.length}
                                                                                        onClick={handleClose}
                                                                                        variant="contained"
                                                                                        component="label"
                                                                                        color="default"
                                                                                    >
                                                                                        Cancel
                                                                                      </Button>
                                                                                </DialogActions>
                                                                            </Dialog>
                                                                        </FormControl>
                                                                    </li>
                                                                </ul>
                                                            </Grid>
                                                        </span>
                                                    );
                                                })
                                                : ''}

                                            <Grid item xs={12} sm={12} className="mt15">
                                                <FormControl fullWidth>
                                                    <InputLabel htmlFor="enter-question" shrink>
                                                        Additional question by {tennantName}
                                                    </InputLabel>
                                                    <Input
                                                        disabled={
                                                            usertype === 'Other employee users' || buttonDisable(stageId, userType.value)
                                                        }
                                                        className={classes.bottomLine}
                                                        id="enter-question"
                                                        name="addQue"
                                                        placeholder="Enter Your Notes"
                                                        value={formik.values.addQue}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            {formik.values.remarksByClient ? (
                                                <Grid item xs={12} sm={12}>
                                                    <FormControl fullWidth>
                                                        <InputLabel htmlFor="enter-question" shrink>
                                                            Remarks by Client
                                                        </InputLabel>
                                                        <Input
                                                            // disabled
                                                            disabled={
                                                                usertype === 'Other employee users' ||
                                                                buttonDisable(stageId, userType.value)
                                                            }
                                                            className="bottom"
                                                            id="enter-question"
                                                            name="remarksByClient"
                                                            placeholder="Enter Your Remarks"
                                                            value={formik.values.remarksByClient}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            ) : null}

                                            {attachedFileIMC && attachedFileIMC.length ? (
                                                <Grid item xs={12} sm={6}>
                                                    <FormControl fullWidth>
                                                        <InputLabel htmlFor="enter-question" shrink>
                                                            Document attached By Client
                                                        </InputLabel>
                                                        {attachedFileIMC.map((file, index) => {
                                                            return (
                                                                <span style={{ paddingTop: '12px' }}>
                                                                    <span style={{ marginRight: '8px' }} className="fileName">
                                                                        {file.substring(file.lastIndexOf('/') + 1).substring(0, 15)}
                                                                    </span>
                                                                    <span onClick={() => handlePreviewModal(file)}>
                                                                        <Tooltip title="Preview">
                                                                            <img
                                                                                src={PreviewImage}
                                                                                alt="PreviewImage"
                                                                                className="fileView"
                                                                            />
                                                                        </Tooltip>
                                                                        <span onClick={() => downloadCoreFile(file)}>
                                                                            <Tooltip title="Download">
                                                                                <img
                                                                                    src={downloadImage}
                                                                                    alt="downloadImage"
                                                                                    className={classes.downloadImg}
                                                                                />
                                                                            </Tooltip>
                                                                        </span>
                                                                    </span>
                                                                </span>
                                                            );
                                                        })}
                                                    </FormControl>
                                                </Grid>
                                            ) : null}
                                        </Grid>
                                    </CardContent>
                                </Card>
                                <div className="footer-button">
                                    <PreviewModal fileSource={downloadFile} visibleClose={visible} handleModalClose={handleModalClose} />
                                    <ul>
                                        <li>
                                            <Button
                                                color="primary"
                                                className="buttonnext txt-cap"
                                                onClick={() => {
                                                    navigateBack();
                                                }}
                                                disabled={
                                                    stageId === 22 ||
                                                    stageId === 23 ||
                                                    stageId === 24 ||
                                                    stageId === 25 ||
                                                    stageId === 26 ||
                                                    stageId === 30 ||
                                                    stageId === 31
                                                }
                                            >
                                                Back
                                            </Button>
                                        </li>

                                        <li>
                                            {showLoaderSave ? (
                                                <LoaderPopUp
                                                    showLoader={showLoaderSave}
                                                    handleClose={handleClose}
                                                    title="Please wait while saving Draft Statements"
                                                />
                                            ) : null}
                                            <Button
                                                color="primary"
                                                className="buttonnext txt-cap"
                                                type="submit"
                                                disabled={usertype === 'Other employee users' || buttonDisable(stageId, userType.value)}
                                            >
                                                Save
                                            </Button>
                                        </li>
                                        <li>
                                            {showLoaderSubmit ? (
                                                <LoaderPopUp
                                                    showLoader={showLoaderSubmit}
                                                    handleClose={handleClose}
                                                    title="Please wait while Submitting your Draft Statements"
                                                />
                                            ) : null}

                                            <Button
                                                disabled={
                                                    usertype === 'EM'
                                                        ? isDisable || buttonDisable(stageId, userType.value)
                                                        : usertype === 'Other employee users' ||
                                                        stageId === 22 ||
                                                        stageId === 23 ||
                                                        stageId === 24 ||
                                                        stageId === 25 ||
                                                        stageId === 26 ||
                                                        stageId === 30 ||
                                                        stageId === 31
                                                }
                                                color="primary"
                                                className="buttonnext txt-cap"
                                                onClick={() => {
                                                    handleSubmitClick(imcdraftsavevalue2, formik.values);
                                                }}
                                            >
                                                Submit
                                            </Button>
                                        </li>
                                    </ul>
                                </div>
                            </form>
                        </>
                    );
                }}
            </Formik>
        </div>
    );
}
